<div class="flex-row justify-between items-start">
  <h2 mat-dialog-title>{{ title }}</h2>
  <button mat-button class="close-icon" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</div>

<section class="checkbox-section">
  <mat-radio-group [formControl]="documentType">
    <mat-radio-button class="checkbox" value="pdf" [checked]="true">
      {{ 'generic.pdf' | translate | uppercase }}
    </mat-radio-button>
    @if (programDownloadType.value === 'material') {
      <mat-radio-button class="checkbox" value="excel">{{ 'generic.excel' | translate | titlecase }}</mat-radio-button>
    }
  </mat-radio-group>
</section>

@if (!loading) {
  <div mat-dialog-content>
    <p>{{ description }}</p>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'download_program_pdf_dialog.type.label' | translate}}</mat-label>
      <mat-select [formControl]="programDownloadType">
        @for (typeOption of downloadOptions; track typeOption) {
          <mat-option [value]="typeOption.value">
            {{ typeOption.label | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (getCheckboxOptionsOfDownloadOption(); as checkboxOptions) {
      @for (checkboxOption of checkboxOptions; track checkboxOption) {
        <div class="flex-row flex-wrap">
          <mat-checkbox color="primary" [formControl]="checkboxOption.control">
            <p>{{ checkboxOption.label | translate }}</p>
          </mat-checkbox>
        </div>
      }
    }
    @if (getSelectOptionsOfDownloadOption(); as selectOptions) {
      <mat-form-field appearance="outline">
        <mat-label>{{ selectOptions.label | translate }}</mat-label>
        <mat-select [formControl]="selectOptions.control" [multiple]="selectOptions.multipleSelection">
          @if ((selectOptions.options.length === 0) && selectOptions.allOptionsLabel) {
            <mat-option value="">
              {{ selectOptions.allOptionsLabel | translate }}
            </mat-option>
          }
          @for (selectOption of selectOptions.options; track selectOption) {
            <mat-option [value]="selectOption.id">
              {{ selectOption.name || selectOption.display_name || selectOption.filename }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (selectOptions.control.hasError('invalid') || selectOptions.control.hasError('required')) {
        <mat-error>
          {{ selectOptions.invalidLabel | translate }}
        </mat-error>
      }
      @if (selectOptions.addSelectAllOption && selectOptions.options.length !== 0) {
        <mat-checkbox color="primary" [formControl]="selectAllSelectOptionsControl">
          <span>{{ 'download_program_pdf_dialog.deselect_all' | translate }}</span>
        </mat-checkbox>
      }
    }
  </div>
}
@if (loading) {
  <div mat-dialog-content>
    <p>{{ 'download_program_pdf_dialog.loading' | translate }}</p>
  </div>
}
<div mat-dialog-actions>
  <button mat-button [disabled]="loading" (click)="onNoClick()">
    {{ 'generic.cancel' | translate | uppercase }}
  </button>
  <div class="flex-row">
    <button
      mat-button
      color="primary"
      (click)="confirm()"
      [disabled]="loading || hasNoActivitiesSelected()"
      cdkFocusInitial
      >
      {{ 'generic.ok' | translate }}
    </button>
    @if (loading) {
      <mat-progress-spinner
        diameter="30"
        color="primary"
        mode="indeterminate"
      ></mat-progress-spinner>
    }
  </div>
</div>
